import { styled } from '@creditas-ui/react'
import { hexToRgb } from 'shared/helpers'
import { PULSING_VARIANTS } from 'domain/enums'

const defineColor = ({ theme, variant, opacity }) => {
  const colorVariantKeys = {
    [PULSING_VARIANTS.PENDING]: theme.colors.warning[60],
    [PULSING_VARIANTS.REJECTED]: theme.colors.error[60],
    [PULSING_VARIANTS.INFO]: theme.colors.informational[60],
    [PULSING_VARIANTS.PAYMENT]: theme.colors.primary[60],
  }

  const { r, g, b } = hexToRgb(colorVariantKeys[variant])

  return `rgba(${r},${g},${b}, ${opacity})`
}

const Container = styled.div`
  display: flex;
`

const PulsingInner = styled.div`
  border-radius: 50%;
  margin: 10px;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  background: ${({ variant, theme }) =>
    defineColor({ theme, variant, opacity: 1 })};
  transform: scale(1);
  box-shadow: 0 0 0 0
    ${({ theme, variant }) => defineColor({ theme, variant, opacity: 1 })};
  animation: pulse-circle 2s infinite;

  @keyframes pulse-circle {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0
        ${({ theme, variant }) => defineColor({ variant, theme, opacity: 0.7 })};
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px
        ${({ theme, variant }) => defineColor({ theme, variant, opacity: 0 })};
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0
        ${({ theme, variant }) => defineColor({ theme, variant, opacity: 0 })};
    }
  }
`

const Inner = styled.div`
  border-radius: 50%;
  margin: 10px;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  background: ${({ theme, variant }) =>
    defineColor({ theme, variant, opacity: 1 })};
`

export { Container, PulsingInner, Inner }
